import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
import {Link, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";

function LockScreen() {
    const [countDown, setCountDown] = useState(6);
    const navigate = useNavigate();

    useEffect(() => {
        if (countDown <= 0){
            navigate("/ai-chatbot", { replace: true });
            return;
        }

        const timer = setInterval(() => {
            setCountDown(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countDown]);

    return (
        <div className="px-xxl-5">
            <div className="text-center mb-6">
                <div className="mb-3">
                    <div>
                        <FontAwesomeIcon className="text-danger fw-bold" icon={faTriangleExclamation} />
                    </div>

                    <h4 className="mb-3 text-danger">Access Denied</h4>
                    <p className="text-body-tertiary fs-8-1 mb-1">
                        You don’t have permission to access this page.
                        <br/>Please contact the administrator if you believe this is a mistake.
                    </p>
                </div>

                <p className="fs-8-1">
                    You will be redirected to the main page in
                    <br/>
                    <strong className="ms-1">{countDown}</strong> seconds.
                    <br/>If not, please click the button below.
                </p>

                <p>
                    <Link className="w-100 mb-3 fs-8-1 fw-bold" to="/ai-chatbot">
                        <FontAwesomeIcon className="me-2" icon={faChevronLeft} />
                        Go to main page
                    </Link>
                </p>
            </div>
        </div>

    )
}
export default LockScreen;